module.exports = __webpack_public_path__ + "static/0065-52346b15cff6978b1aa269f7ffc58bfa.png";